import openMVImage from '../components/product/images/OpenMV.svg';
import cliImage from '../components/product/images/SoftwareCLI.svg';
import ideImage from '../components/product/images/SoftwareIDE.svg';
import ide2Image from '../components/product/images/SoftwareIDEv2.svg';
import iotImage from '../components/product/images/SoftwareIoT.svg';
import linuxImage from '../components/product/images/SoftwareLinux.svg';
import plcImage from '../components/product/images/SoftwarePLC.svg';
import webEditorImage from '../components/product/images/SoftwareWebEditor.svg';

export const PROGRAMMING_PAGE = '/programming/';
export const SOFTWARE_PAGE = '/software/';
export const SOFTWARE_IDE_PAGE = '/software/ide/';
export const SOFTWARE_PLC_PAGE = '/software/plc-ide/';
export const RETIRED_PAGE = '/retired/';
export const HARDWARE_PAGE = '/hardware/';
export const MICROPYTHON_PAGE = '/micropython/';
export const CLOUD_PAGE = '/arduino-cloud/';
export const LEARN_PAGE = '/learn/';
export const EXAMPLES_PAGE = '/built-in-examples/';
export const TUTORIALS_PAGE = '/tutorials';
export const HOME_PAGE = '/';

export const CLOUD_PATH = 'arduino-cloud';
export const PRODUCT_PATH = 'hardware';
export const HARDWARE_PATH = 'tutorials';
export const TUTORIALS_PATH = 'tutorials';
export const MYCROPYTHON_PATH = 'micropython';
export const SOFTWARE_PATH = 'software';
export const SOFTWARE_IDE_PATH = 'ide-v2';
export const SOFTWARE_PLC_PATH = 'plc-ide';
export const LEARN_PATH = 'learn';
export const EXAMPLES_PATH = 'built-in-examples';
export const LANGUAGE_REFERENCE_PATH = 'language-reference';
export const RETIRED_PATH = 'retired';

export const TUTORIAL_COMMUNICATION = 'communication';
export const TUTORIAL_GENERIC = 'generic';
export const TUTORIAL_PROJECT = 'projects';
export const TUTORIAL_NANO_GENERIC = 'nano-generic';
export const TUTORIAL_SECURITY = 'security';

export const SIDEBAR_CLOUD = 'Cloud';
export const SIDEBAR_TUTORIALS = 'Tutorials';
export const SIDEBAR_HARDWARE = 'Hardware';
export const SIDEBAR_MYCROPYTHON = 'MicroPython';
export const SIDEBAR_PROGRAMMING = 'Programming';
export const SIDEBAR_SOFTWARE = 'Software';
export const SIDEBAR_IDE_SOFTWARE = 'Arduino IDE';
export const SIDEBAR_PLC_SOFTWARE = 'Arduino IDE PLC';
export const SIDEBAR_LEARN = 'Learn';
export const SIDEBAR_EXAMPLES = 'Built-in Examples';
export const SIDEBAR_LANGUAGE = 'Language Reference';
export const SIDEBAR_RETIRED = 'Retired';

export const LINK_FORUM = 'https://forum.arduino.cc/';
export const LINK_HELP_CENTER = 'https://support.arduino.cc/';

export const MAKER = 'maker';
export const PRO = 'pro';
export const EDU = 'edu';

export const LVL_BEGINNER = 'beginner';
export const LVL_INTERMEDIATE = 'intermediate';
export const LVL_ADVANCED = 'advanced';

export const TEMP_LIBRARY_EXAMPLE = '07.library-examples';

export const MOBILE_OPEN = 'mobileOpen';

export const BACK = 'GO BACK';

export const hardwareCard = [
  {
    id: 0,
    title: 'Learn Arduino',
    description: 'Basic knowledge about principles and techniques behind the Arduino ecosystem.',
    icon: 'IconUniversityHat',
    link: '/learn',
  },
  {
    id: 1,
    title: 'Hardware Support',
    description: 'Find Frequently Asked Questions and troubleshooting articles.',
    icon: 'IconQuestion',
    link: 'https://support.arduino.cc/hc/en-us/articles/9264736457500',
    external: true,
  },
  {
    id: 2,
    title: 'Retired Boards',
    description: 'Discover the history of Arduino through all the boards and other documentation released.',
    icon: 'IconBoard',
    link: '/retired',
  },
  // { // FIXME - WAIT LINK
  //   id: 3,
  //   title: 'Hardware security',
  //   description:
  //     'Learn how Arduino ensures the security of the software and network connectivity in hardware products in this security overview document.',
  //   icon: 'IconBoard',
  //   link: '/todo',
  // },
];

export const homePageDiscoverCard = [
  {
    id: 0,
    title: 'Learn Arduino',
    description: 'Basic knowledge about principles and techniques behind the Arduino ecosystem.',
    icon: 'IconUniversityHat',
    link: '/learn/',
  },
  {
    id: 1,
    title: 'Tutorials',
    description: 'Discover all available Arduino official tutorials.',
    icon: 'IconPlay',
    link: '/tutorials/',
    external: true,
  },
];

export const homePageCommunityCard = [
  {
    id: 0,
    title: 'Community Forum',
    description: 'Find out topics and tips or connect with users from the Arduino Forum.',
    icon: 'IconUsers',
    link: 'https://forum.arduino.cc/',
    external: true,
  },
  {
    id: 1,
    title: 'Arduino Discord',
    description: 'Official space for connecting with the Arduino community to talk about all things Arduino.',
    icon: 'IconDiscord',
    link: 'https://discord.com/invite/jQJFwW7',
    external: true,
  },
  {
    id: 2,
    title: 'YouTube channel',
    description: 'Explore the official video channel for all projects, insights and interviews related to Arduino.',
    icon: 'IconYoutube',
    link: 'https://www.youtube.com/@Arduino',
    external: true,
  },
  {
    id: 3,
    title: 'Help Center',
    description: 'FAQ and troubleshooting articles, created by the Support team.',
    icon: 'IconHelpCenter',
    link: 'https://support.arduino.cc/',
    external: true,
  },
  {
    id: 4,
    title: 'Project Hub',
    description: 'Join millions of amazing Arduino community members worldwide in documenting your projects.',
    icon: 'IconProjectHub',
    link: 'https://projecthub.arduino.cc/',
    external: true,
  },
];

export const homePageNavigation = [
  {
    id: 0,
    name: 'Hardware',
    url: '/hardware',
    icon: 'IconHardware',
  },
  {
    id: 1,
    name: 'Software',
    url: '/software',
    icon: 'IconSoftware',
  },
  {
    id: 2,
    name: 'Cloud',
    url: '/arduino-cloud',
    icon: 'IconCloud',
  },
  {
    id: 3,
    name: 'Programming',
    url: '/programming',
    icon: 'IconProgramming',
  },
  {
    id: 4,
    name: 'Learn',
    url: '/learn',
    icon: 'IconLearn',
  },
];

export const programmingNavigation = [
  {
    id: 0,
    name: 'Language Reference',
    url: 'https://www.arduino.cc/reference/en/', //'/language-reference/',
    icon: 'IconHardware',
  },
  {
    id: 1,
    name: 'Libraries',
    url: 'https://www.arduino.cc/reference/en/libraries/', //'/libraries',
    icon: 'IconSoftware',
  },
  {
    id: 2,
    name: 'Built-in Examples',
    url: '/built-in-examples',
    icon: 'IconCloud',
  },
  {
    id: 3,
    name: 'MicroPython',
    url: '/micropython/',
    icon: 'IconProgramming',
  },
  {
    id: 4,
    name: 'Cloud API',
    url: 'https://www.arduino.cc/reference/en/iot/api/', //, //'/cloud-api/',
    icon: 'IconLearn',
  },
];

export const microPythonTutorials = {
  boards: [
    {
      displayname: 'Getting Started',
      releases: [
        {
          name: 'Arduino Nano RP2040 Connect',
          source: '/tutorials/nano-rp2040-connect/rp2040-openmv-setup',
          type: null,
        },
        {
          name: ' Arduino Nano BLE Sense',
          source: '/tutorials/nano-33-ble-sense/getting-started-omv',
          type: null,
        },
        {
          name: 'Arduino Portenta H7',
          source: '/tutorials/portenta-h7/getting-started-openmv-micropython',
          type: null,
        },
        {
          name: ' Arduino Nicla Vision',
          source: '/tutorials/nicla-vision/getting-started',
          type: null,
        },
      ],
    },
    {
      displayname: 'Arduino Nano',
      releases: [
        {
          name: 'Arduino Nano RP2040 Connect Python API Guide',
          source: '/tutorials/nano-rp2040-connect/rp2040-python-api',
          type: null,
        },
        {
          name: 'Arduino Nano BLE Sense Python API Guide',
          source: '/tutorials/nano-33-ble-sense/ble-sense-python-api',
          type: null,
        },
      ],
    },
    {
      displayname: 'OpenMV',
      releases: [
        {
          name: 'Connecting to The Things Network Using OpenMV',
          source: '/tutorials/portenta-vision-shield/things-network-openmv',
          type: null,
        },
        {
          name: 'Blob Detection with Portenta and OpenMV',
          source: '/tutorials/portenta-vision-shield/blob-detection',
          type: null,
        },
      ],
    },
    {
      displayname: 'Portenta H7',
      releases: [
        {
          name: 'Arduino Portenta H7 MicroPython Cheat Sheet',
          source: '/tutorials/portenta-h7/openmv-cheat-sheet',
          type: null,
        },
      ],
    },
  ],
};

export const INTERACTIVE = [
  {
    // board preview for altium
    file: 'altium.zip',
  },
  {
    // encrypted board preview for altium
    file: 'altium.zip.gpg',
  },
  {
    // simplified pinout from a image file
    file: 'pinout.png',
  },
];

// DOWNLOADABLES contains a mapping between the download buttons and the files to reference.
// The files are passed to the component as graphql nodes.
// To add a new button, update this list
export const DOWNLOADABLES = [
  {
    name: 'Pinout (PDF)',
    file: 'full-pinout.pdf',
    icon: 'IconFullPinout',
  },
  {
    name: 'Datasheet',
    file: 'datasheet.pdf',
    icon: 'IconDatasheet',
  },
  {
    name: 'Schematics',
    file: 'schematics.pdf',
    icon: 'IconDownloadSchematics',
  },
  {
    name: 'CAD Files' /*If eagle-files.zip is detected, label them as CAD Files. This can be removed if ALL files have been renamed to cad-files.zip */,
    file: 'eagle-files.zip',
    icon: 'IconCAD',
  },
  {
    name: 'Fritzing Files',
    file: 'fritzing.fzpz',
    icon: 'IconFritzingFiles',
  },
  {
    name: 'CAD Files',
    file: 'cad-files.zip',
    icon: 'IconCAD',
  },
  {
    name: 'Altium Files',
    file: 'altium-files.zip',
  },
  {
    name: 'DFX - Board Dimensions',
    file: 'dfx.zip',
    icon: 'IconFullPinout',
  },
  {
    name: 'STL Files',
    file: 'stl.zip',
    icon: 'IconFullPinout',
  },
  {
    name: 'STEP Files',
    file: 'step.zip',
    icon: 'IconFullPinout',
  },
  {
    name: 'Pinout Table',
    file: 'pinout-table.pdf',
    icon: 'IconFullPinout',
  },
  {
    name: 'Software Mapping',
    file: 'software-pinout-mapping.pdf',
    icon: 'IconFullPinout',
  },
];

export const SOFTWARE_IMAGES = {
  'ide-v1': {
    image: ideImage,
    text: 'Arduino IDE',
    url: '../../../software/ide-v1',
  },
  'ide-v2': {
    image: ide2Image,
    text: 'Arduino IDE 2',
    url: '../../../software/ide-v2',
  },
  'arduino-cli': {
    image: cliImage,
    text: 'Arduino CLI',
    url: 'https://arduino.github.io/arduino-cli/',
  },
  'iot-cloud': {
    image: iotImage,
    text: 'Arduino IoT Cloud',
    url: 'https://create.arduino.cc/iot',
  },
  'web-editor': {
    image: webEditorImage,
    text: 'Arduino Web Editor',
    url: 'https://create.arduino.cc/editor',
  },
  'manager-linux': {
    image: linuxImage,
    text: 'Manager for Linux',
    url: 'https://create.arduino.cc/devices/',
  },
  'openmv-ide': {
    image: openMVImage,
    text: 'OpenMV IDE',
    url: 'https://openmv.io/pages/download',
  },
  'plc-ide': {
    image: plcImage,
    text: 'Arduino PLC IDE',
    url: '../../../software/plc-ide',
  },
};
